import React from 'react';
import PropTypes from 'prop-types';

import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';

import TextFieldsIcon from '@mui/icons-material/TextFields';

import DeleteIcon from '@mui/icons-material/Delete';
import SettingsIcon from '@mui/icons-material/Settings';

import { IconContainer, ImagePreview, InputPreview, useStyles } from './styles';

export default function FileInputPreview({
  hasSettings,
  id,
  isImage,
  isText,
  onChangeText,
  onClickSettings,
  onDelete,
  url,
  value,
}) {
  const classes = useStyles();

  return (
    <Box className={classes.container}>
      {isImage && url && <ImagePreview src={url} alt="image" />}
      {isText && (
        <IconContainer>
          <TextFieldsIcon />
        </IconContainer>
      )}
      <InputPreview
        as={isText ? 'textarea' : undefined}
        disabled={isImage}
        onChange={(e) => onChangeText(id, e.target.value)}
        value={url || value}
      />
      {hasSettings && (
        <IconButton
          onClick={() => onClickSettings({ id, isImage, isText, url })}
          size="large"
        >
          <SettingsIcon color="action" />
        </IconButton>
      )}
      <IconButton onClick={() => onDelete(url || id)} size="large">
        <DeleteIcon color="error" />
      </IconButton>
    </Box>
  );
}

FileInputPreview.propTypes = {
  hasSettings: PropTypes.bool,
  id: PropTypes.string,
  isImage: PropTypes.bool,
  isText: PropTypes.bool,
  onChangeText: PropTypes.func,
  onClickSettings: PropTypes.func,
  onDelete: PropTypes.func,
  url: PropTypes.string,
  value: PropTypes.string,
};

FileInputPreview.defaultProps = {
  hasSettings: false,
  id: '',
  isImage: false,
  isText: false,
  onChangeText: () => {},
  onDelete: () => {},
  url: '',
  value: '',
};
